module.exports = "<router-outlet>\r\n    <app-spinner></app-spinner>\r\n</router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/layout/auth-candidate/auth-candidate.component.html
// module id = ../../../../../src/app/layout/auth-candidate/auth-candidate.component.html
// module chunks = main